import { render, staticRenderFns } from "./CorporationInfo0.vue?vue&type=template&id=3417899a"
import script from "./CorporationInfo0.vue?vue&type=script&lang=js"
export * from "./CorporationInfo0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3417899a')) {
      api.createRecord('3417899a', component.options)
    } else {
      api.reload('3417899a', component.options)
    }
    module.hot.accept("./CorporationInfo0.vue?vue&type=template&id=3417899a", function () {
      api.rerender('3417899a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfo0.vue"
export default component.exports